export default __webpack_public_path__ + "static/media/plan.d3bf6fee.svg";